import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-research-project',
  templateUrl: './research-project.component.html',
  styleUrls: ['./research-project.component.scss']
})
export class ResearchProjectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
